import { StylesConfig } from 'react-select'
import { getCSSVariableValue } from '../_metronic/assets/ts/_utils'
import { MultiSelectOptionType, SelectOptionType } from './MultiSelect'

export const selectCustomStyles: StylesConfig<SelectOptionType | MultiSelectOptionType> = {
  control: (provided: any, state) => {
    return {
      ...provided,
      backgroundColor: getCSSVariableValue('--kt-table-bg'),
      borderColor: getCSSVariableValue('--kt-primary'),
      border: state.isFocused
        ? '1px solid ' + getCSSVariableValue('--kt-primary')
        : '1px solid #cccccc',
      boxShadow: state.isFocused ? '0px 0px 1px ' + getCSSVariableValue('--kt-primary') : 'none',
      '&:hover': {
        color: getCSSVariableValue('--kt-primary'),
        border: '1px solid ' + getCSSVariableValue('--kt-primary'),
        boxShadow: '0px 0px 1px ' + getCSSVariableValue('--kt-primary'),
      },
    }
  },
  menu: (provided: any, state) => {
    return {
      ...provided,
      backgroundColor: getCSSVariableValue('--kt-table-active-bg'),
      zIndex: 9999,
    }
  },
  option: (styles: any, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? getCSSVariableValue('--kt-primary-light')
        : isFocused
        ? getCSSVariableValue('--kt-primary')
        : undefined,
      color: isDisabled ? '#ccc' : isFocused ? 'white' : getCSSVariableValue('--kt-gray-heading'),

      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? getCSSVariableValue('--kt-primary')
            : getCSSVariableValue('--kt-primary-light')
          : undefined,
      },
    }
  },
  singleValue: (styles: any, { data }) => {
    return {
      ...styles,
      color: getCSSVariableValue('--kt-input-color'),
    }
  },
    placeholder: (base: any) => ({
    ...base,
    fontSize: '12px', 
    color: '#a8acbc',    
  }),
  input: (styles: any) => {
    return {
      ...styles,
      color: getCSSVariableValue('--kt-body-color'),
    }
  },
}
